<template>
  <modal v-if="show" :title="i18n.t('/FleetContracts/Search/Title')" @close="close">
    <fleet-contract-search-box :info-text="searchInfoText" @on-search="onSearch" />
    <loader v-if="isSearching" />

    <ul v-if="foundContracts.length">
      <li v-for="contract in contractsToShow" :key="contract.ContractNumber">
        <fleet-contract-card :contract="contract" @select-result="selectContract" />
      </li>
    </ul>
    <div v-if="showNoResultsMessage">
      <p>{{ i18n.t('/FleetContracts/Search/NoResults') }}</p>
    </div>

    <app-button
      v-if="amountToShow <= foundContracts.length"
      data-qa="show-more-fleet-contracts-button"
      @click="showMoreResults()"
    >
      {{ i18n.t('/FleetContracts/Search/ShowMore') }}
    </app-button>
  </modal>
</template>

<script>
import FleetContractSearchBox from '@/components/generic/presentational/molecules/fleetContractSearchBox/FleetContractSearchBox.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import FleetContractCard from '@/components/generic/presentational/molecules/fleetContractCard/FleetContractCard.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'

export default {
  components: {
    FleetContractSearchBox,
    Modal,
    FleetContractCard,
    Loader,
    AppButton,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isSearching: {
      type: Boolean,
      default: false,
    },
    hasRecommendedContract: {
      type: Boolean,
      default: false,
    },
    foundContracts: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['close', 'search', 'select'],
  data() {
    return {
      hasSearched: false,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      amountToShow: 20,
    }
  },
  computed: {
    showNoResultsMessage() {
      return this.foundContracts.length == 0 && this.hasSearched && !this.isSearching
    },
    contractsToShow() {
      return this.foundContracts.filter((_contract, index) => index < this.amountToShow)
    },
    searchInfoText() {
      if (this.hasRecommendedContract)
        return this.i18n.t('/FleetContracts/Search/HasRecommendedContractText')
      else return this.i18n.t('/FleetContracts/Search/Info')
    },
  },
  methods: {
    close() {
      this.amountToShow = 20
      this.hasSearched = false
      this.$emit('close')
    },
    onSearch(query) {
      this.$emit('search', query, false)
      this.hasSearched = true
    },
    selectContract(contract) {
      this.$emit('select', contract)
    },
    showMoreResults() {
      this.amountToShow += 20
    },
  },
}
</script>

<style lang="scss" scoped>
ul {
  @include list-reset;
}
</style>
